import FBAPI from '../FBAPI';

const enquires = {
    saveEnquiry: async (data) => FBAPI.saveEnquiry(data),
};

export default enquires;
